import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ChangePassword from './pages/ChangePassword';
import UserManagement from './pages/UserManagement';
import FileManager from './pages/FileManager';
import Folders from './pages/Folders';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
  path="/files/:id"
  element={
    <PrivateRoute>
      <FileManager />
    </PrivateRoute>
  }
/>
          <Route  path="/folders/:id" element={
               <PrivateRoute>
                 <Folders/>
              </PrivateRoute>
          }
         />  <Route  path="/folders" element={
               <PrivateRoute>
                 <Folders/>
              </PrivateRoute>
          }
         />
          <Route  path="/users" element={
               <PrivateRoute>
                 <UserManagement />
              </PrivateRoute>
          }
         />
          <Route  path="/change-password" element={
               <PrivateRoute>
                 <ChangePassword />
              </PrivateRoute>
          }
         />
          <Route path="*" element={<Login />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;